import { DefaultOptionType } from "antd/es/select";
import { loadObjectAttrinbutesReduced } from "src/pages/ManagementPage/objectsApi";
import { ZAttribute } from "src/types/ZAttribute";
import { ZUid } from "src/types/zUid";

export const loadAllObjectAttsOptions = async (
  refId: ZUid | null | undefined,
  filterFn?: (attr: ZAttribute) => boolean,
): Promise<DefaultOptionType[]> =>
  refId
    ? loadObjectAttrinbutesReduced(refId).then((atts) =>
        atts
          .filter((attr) => (filterFn ? filterFn(attr) : true))
          .map((attr) => ({
            label: attr.name.trim(),
            value: String(attr.id),
          }))
          .sort((a, b) => a.label.localeCompare(b.label)),
      )
    : [];
